import React, { useState } from "react";
import authorPortrait from "./img/06345.png";
import reviewPhoto1 from "./img/com_1.png";
import reviewPhoto2 from "./img/com_2.jpg";
import reviewPhoto3 from "./img/com_3.png";
import reviewPhoto4 from "./img/com_4.png";
import reviewPhoto5 from "./img/com_5.png";
import "./App.css";

function SvisScaleSection() {
  return (
    <section className="svis-scale" id="scale">
      <div className="svis-scale__head">
        <div className="svis-scale__intro">
          <span>География · Образование · Практика</span>
          <h2>Масштаб применения SVIS</h2>
          <p>За несколько лет Stepanova Vocal Integration System (SVIS) прошла путь от авторской педагогической разработки до профессиональной методической системы, применяемой в академическом музыкальном образовании, программах подготовки преподавателей и профессиональной подготовке вокалистов.</p>
          <p>Сегодня методика используется не только автором, но и независимыми образовательными учреждениями, преподавателями вокального искусства и профессиональными исполнителями, что подтверждает ее практическую востребованность и воспроизводимость в различных образовательных форматах.</p>
        </div>
        <div className="svis-scale__music" aria-hidden="true">
          <div className="svis-scale__vinyl"><b>МАСШТАБ<small>SVIS</small></b></div>
          <i className="svis-scale__tonearm" />
          <div className="svis-scale__equalizer">
            {[42, 72, 54, 88, 63, 34, 76, 48].map((height, index) => (
              <span key={index} style={{ "--bar-height": `${height}%`, "--bar-index": index }} />
            ))}
          </div>
        </div>
      </div>

      <div className="svis-scale__cards">
        <article className="svis-scale__card svis-scale__card--wide">
          <div className="svis-scale__metric"><strong>6</strong><span>ведущих музыкальных академий и консерваторий</span></div>
          <h3>Период внедрения: 2022–2025 гг.</h3>
          <p>В течение нескольких лет Методика регистровой интеграции и управляемого расширения вокального диапазона получила официальное применение в ведущих высших музыкальных учебных заведениях.</p>
          <p>Использование методики подтверждено следующими учреждениями:</p>
          <ul>
            <li>Национальная музыкальная академия Украины имени П. И. Чайковского;</li>
            <li>Московская государственная консерватория имени П. И. Чайковского;</li>
            <li>Казахская национальная консерватория имени Курмангазы;</li>
            <li>Одесская национальная музыкальная академия имени А. В. Неждановой;</li>
            <li>Харьковский национальный университет искусств имени И. П. Котляревского;</li>
            <li>Киевская муниципальная академия музыки имени Р. М. Глиэра.</li>
          </ul>
          <p>В указанных учреждениях методика используется при профессиональной подготовке вокалистов, совершенствовании исполнительских навыков, развитии регистровой координации и внедрении современных педагогических подходов в образовательный процесс.</p>
        </article>

        <article className="svis-scale__card">
          <div className="svis-scale__metric"><strong>3</strong><span>страны институционального применения</span></div>
          <h3>Украина • Казахстан • Россия</h3>
          <p>По состоянию на 2025 год применение методики подтверждено образовательными учреждениями трех государств.</p>
          <p>Международная география использования свидетельствует о том, что разработанная система получила распространение за пределами одного образовательного учреждения и применяется в различных национальных моделях профессионального музыкального образования.</p>
        </article>

        <article className="svis-scale__card svis-scale__card--accent">
          <div className="svis-scale__metric"><strong>2021</strong><span>применение на уровне профессионального образовательного стандарта</span></div>
          <h3>С 2021 года — применение на уровне профессионального образовательного стандарта</h3>
          <p>Начиная с 2021 года методологические принципы Методики регистровой интеграции и управляемого расширения вокального диапазона используются Ассоциацией деятелей искусств в качестве основы отраслевого стандарта подготовки вокалистов, рекомендованного образовательным учреждениям стран СНГ.</p>
          <p>Это решение стало важным этапом развития методики и подтвердило возможность применения разработанной системы не только в индивидуальной педагогической практике, но и при формировании единых профессиональных подходов к подготовке вокалистов.</p>
        </article>

        <article className="svis-scale__card">
          <div className="svis-scale__metric"><strong>179</strong><span>преподавателей вокального искусства</span></div>
          <h3>Подготовлены по системе SVIS (2021–2025 гг.)</h3>
          <p>За период с 2021 по 2025 год обучение по авторской системе Stepanova Vocal Integration System прошли 179 преподавателей вокального искусства.</p>
          <p>В рамках программы преподаватели освоили:</p>
          <ul>
            <li>принципы функциональной диагностики голоса;</li>
            <li>методы регистровой интеграции;</li>
            <li>алгоритмы управляемого расширения вокального диапазона;</li>
            <li>применение системы SVIS Vocal Profile Assessment;</li>
            <li>использование SVIS Vocal Range Map;</li>
            <li>критерии оценки профессионального прогресса вокалистов;</li>
            <li>методику адаптации системы к различным типам голосов.</li>
          </ul>
          <p>После прохождения подготовки специалисты используют элементы методики в собственной педагогической практике, обучая студентов музыкальных академий, профессиональных исполнителей и участников специализированных образовательных программ.</p>
        </article>

        <article className="svis-scale__card">
          <div className="svis-scale__metric"><strong>398</strong><span>профессиональных вокалистов</span></div>
          <h3>Прошли обучение по методике SVIS (2020–2025 гг.)</h3>
          <p>С момента создания методики обучение с использованием Stepanova Vocal Integration System прошли 398 профессиональных вокалистов.</p>
          <p>Программа применяется при:</p>
          <ul>
            <li>развитии функционального вокального диапазона;</li>
            <li>совершенствовании регистровой координации;</li>
            <li>сохранении индивидуального тембра;</li>
            <li>подготовке концертного репертуара;</li>
            <li>восстановлении устойчивой исполнительской техники;</li>
            <li>подготовке к профессиональной сценической деятельности.</li>
          </ul>
          <p>Методика используется как в индивидуальной работе с исполнителями, так и в рамках образовательных программ, мастер-классов и специализированных интенсивов.</p>
        </article>

        <article className="svis-scale__card svis-scale__card--wide">
          <div className="svis-scale__metric"><strong>9</strong><span>образовательных программ</span></div>
          <h3>Интеграция отдельных модулей SVIS (2022–2025 гг.)</h3>
          <p>Отдельные диагностические и педагогические инструменты Stepanova Vocal Integration System внедрены в девять образовательных программ, реализуемых музыкальными академиями, консерваториями и учреждениями дополнительного профессионального образования.</p>
          <p>В образовательный процесс интегрированы такие элементы системы, как:</p>
          <ul>
            <li>SVIS Vocal Profile Assessment;</li>
            <li>SVIS Vocal Range Map;</li>
            <li>принципы регистровой интеграции;</li>
            <li>алгоритмы управляемого расширения диапазона;</li>
            <li>SVIS Five-Point Stability Test;</li>
            <li>система оценки профессионального прогресса SVIS Progress Index.</li>
          </ul>
          <p>Использование единых методических инструментов позволяет преподавателям применять стандартизированные подходы к диагностике, обучению и оценке развития профессиональных вокалистов.</p>
        </article>
      </div>

      <div className="svis-scale__outro">
        <span>International development</span>
        <h3>Международное развитие методики</h3>
        <p>За годы практического применения Stepanova Vocal Integration System (SVIS) сформировалась как современная профессиональная педагогическая система, объединяющая исполнительскую практику, вокальную педагогику и образовательные технологии.</p>
        <p>Сегодня методика применяется в нескольких странах, используется образовательными учреждениями, внедряется в программы подготовки преподавателей и профессиональных вокалистов, а также продолжает развиваться в сотрудничестве с музыкальными академиями, консерваториями и профессиональными объединениями.</p>
        <p>Благодаря сочетанию авторской научно-методической концепции, институционального внедрения, подготовки преподавателей и практического применения в системе музыкального образования SVIS продолжает расширять свое присутствие в международном профессиональном сообществе и способствует развитию современных стандартов подготовки вокалистов.</p>
      </div>
    </section>
  );
}

function SvisImpactLead() {
  return (
    <section className="svis-impact-lead">
      <div className="svis-impact__label"><i /> Professional impact</div>
      <div className="svis-impact-lead__layout">
        <h2>Влияние SVIS на профессиональную вокальную подготовку</h2>
        <div className="svis-impact__copy">
          <p>Stepanova Vocal Integration System (SVIS) была разработана как воспроизводимая педагогическая система, предназначенная не только для индивидуальной работы автора с исполнителями, но и для использования другими преподавателями, музыкальными академиями и профессиональными образовательными учреждениями.</p>
          <p>Внедрение методики в академическую образовательную среду позволило использовать единые принципы диагностики вокального диапазона, регистровой интеграции, последовательного расширения функционального диапазона и оценки профессионального прогресса вокалистов.</p>
          <p>Одним из ключевых результатов применения SVIS стало формирование стандартизированного подхода к работе с переходными зонами голоса. Вместо оценки диапазона исключительно по максимальной доступной ноте система предлагает оценивать функциональный вокальный диапазон — совокупность нот, которыми исполнитель способен стабильно управлять в музыкальном материале.</p>
          <p>Методика также ввела структурированный подход к переводу новой ноты из потенциальной зоны в устойчивый рабочий диапазон посредством последовательных этапов диагностики, стабилизации, регистровой интеграции, тембральной адаптации и переноса навыка в профессиональный репертуар.</p>
          <p>Применение SVIS в работе преподавателей позволяет использовать единый алгоритм педагогического наблюдения и отслеживания прогресса исполнителя, сохраняя при этом индивидуальную адаптацию программы к особенностям каждого голоса.</p>
        </div>
      </div>
    </section>
  );
}

function SvisImpactSection() {
  const cards = [
    {
      title: "Функциональная оценка диапазона",
      text: "SVIS разделяет понятия потенциального и функционального диапазона и позволяет преподавателю оценивать не только физическую доступность нот, но и степень их реальной исполнительской готовности.",
    },
    {
      title: "Картирование переходных зон",
      text: "SVIS Vocal Range Map позволяет структурировать диапазон исполнителя по функциональным зонам и отслеживать переход новых участков голоса из потенциального состояния в устойчивое исполнительское использование.",
    },
    {
      title: "Стандартизация критериев результата",
      text: "SVIS Five-Point Stability Test формирует единые критерии, по которым новая нота признается частью рабочего диапазона: повторяемость, интонационная стабильность, тембральная целостность, регистровая связность и перенос в музыкальный материал.",
    },
    {
      title: "Подготовка преподавателей",
      text: "SVIS позволяет передавать методику другим педагогам как целостную профессиональную систему, а не как совокупность отдельных упражнений.",
    },
    {
      title: "Институциональное применение",
      text: "Система адаптирована для использования в музыкальных академиях, консерваториях, программах профессиональной подготовки и повышения квалификации преподавателей.",
    },
  ];

  return (
    <section className="svis-impact">
      <header className="svis-impact__heading">
        <span>Система в профессиональной практике</span>
        <h2>Ключевые направления влияния SVIS</h2>
      </header>
      <div className="svis-impact__cards">
        {cards.map((card, index) => (
          <article className="svis-impact__card" key={card.title} style={{ "--card-index": index }}>
            <div className="svis-impact__number">
              <span>{String(index + 1).padStart(2, "0")}</span>
              <i />
            </div>
            <div>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}

function SvisMethodContent({ openModule, setOpenModule }) {
  const [activeTool, setActiveTool] = useState("profile");

  return (
    <>

          <section className="svis-section svis-section--major">
        <div className="svis-section__body">
          <h2>О методике</h2>
          <div className="svis-copy">
            <p>Stepanova Vocal Integration System (SVIS) — авторская вокально-педагогическая система, разработанная Татьяной Степановой для последовательной интеграции вокальных регистров, расширения функционального певческого диапазона и формирования устойчивой, управляемой голосовой координации.</p>
            <p>Методика основана на современных принципах вокальной педагогики, физиологии голосообразования, акустики певческого голоса, регистровой координации и моторного обучения.</p>
            <p>В центре SVIS находится принцип функционального диапазона: профессиональный диапазон определяется не предельно высокой или низкой нотой, которую певец способен воспроизвести единично, а совокупностью нот, которыми исполнитель может стабильно управлять в реальном музыкальном материале.</p>
            <p>В рамках системы нота считается полноценной частью рабочего диапазона только тогда, когда исполнитель способен воспроизводить ее точно, повторяемо и контролируемо, соединять с соседними звуками, сохранять качество тембра и использовать ее в музыкальной фразе без выраженного форсирования.</p>
            <p>Поэтому SVIS направлена не на механическое увеличение количества доступных нот, а на перестройку и интеграцию вокальных координаций, благодаря которым новый участок диапазона становится естественной частью профессионального певческого голоса.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major svis-method-today">
        <div className="svis-section__body">
          <div className="svis-used svis-used--method">
            <div><span>SVIS</span><h2>Методика сегодня используется:</h2></div>
            <div className="svis-used__grid">
                <div>музыкальными академиями</div>
                <div>консерваториями</div>
                <div>преподавателями вокала</div>
                <div>профессиональными вокалистами</div>
                <div>программами повышения квалификации</div>
                <div>Ассоциацией деятелей искусств</div>
            </div>
          </div>
        </div>
      </section>



      <section className="svis-section svis-section--major">
        <div className="svis-section__body">
          <h2>Основная концепция SVIS</h2>
          <div className="svis-copy">
            <p>В основе Stepanova Vocal Integration System лежат четыре взаимосвязанные задачи:</p>
            <div className="svis-flow">регистровая интеграция → управляемое расширение диапазона → сохранение тембральной идентичности → перенос новой координации в профессиональное исполнение.</div>
            <p>Методика рассматривает голос как единую динамическую систему, в которой изменение высоты звука требует согласованной работы дыхания, голосового источника, вокального тракта, артикуляции и акустической настройки.</p>
            <p>При движении через диапазон голос естественным образом изменяет характер координации. Особое значение приобретают переходные участки, где исполнитель должен адаптировать работу голосового аппарата к новым акустическим и функциональным условиям.</p>
            <p>Если такая адаптация происходит недостаточно эффективно, певец может компенсировать повышение высоты звука увеличением давления, громкости или мышечного усилия. Это часто приводит к нестабильности верхнего регистра, резкой смене тембра, потере интонационной точности и ощущению «барьера» между различными участками диапазона.</p>
            <p>SVIS меняет сам принцип работы с этой задачей.</p>
            <p>Цель системы заключается не в том, чтобы заставить исполнителя преодолеть переходный участок, а в том, чтобы сформировать функциональный переход между регистрами и постепенно интегрировать новые ноты в уже устойчивую голосовую координацию.</p>
          </div>
        </div>
      </section>

      <section className="svis-price" id="tuition">
        <div className="svis-price__copy">
          <span>Обучение · SVIS Academy</span>
          <h2>Стоимость обучения в академии</h2>
          <div className="svis-price__value">
            <strong>45 000</strong>
            <small>гривен</small>
          </div>
          <a href="#contact">Оставить заявку <i>↘</i></a>
        </div>
        <div className="svis-price__visual svis-price__keyboard" aria-hidden="true">
          <div className="svis-price__keys">
            {Array.from({ length: 10 }, (_, index) => (
              <i key={index} style={{ "--key-index": index }} />
            ))}
            <div className="svis-price__sharps">
              {[1, 2, 4, 5, 6, 8].map((position) => <b key={position} style={{ "--sharp-position": position }} />)}
            </div>
            <span className="svis-price__key-pulse" />
          </div>
          <div className="svis-price__keyboard-scale"><span>LOW</span><span>FUNCTIONAL RANGE</span><span>HIGH</span></div>
        </div>
      </section>

      <section className="svis-section svis-section--major">
        <div className="svis-section__body">
          <h2>Ключевой принцип: функциональный вокальный диапазон</h2>
          <div className="svis-copy">
            <p>SVIS разграничивает два понятия:</p>
            <p>Потенциальный диапазон</p>
            <p>Совокупность звуков, которые исполнитель физически способен воспроизвести.</p>
            <p>Функциональный рабочий диапазон</p>
            <p>Совокупность звуков, которые исполнитель способен использовать:</p>
            <div className="svis-line"><i /><span>стабильно;</span></div>
            <div className="svis-line"><i /><span>интонационно точно;</span></div>
            <div className="svis-line"><i /><span>с контролируемой атакой;</span></div>
            <div className="svis-line"><i /><span>с сохранением тембральной целостности;</span></div>
            <div className="svis-line"><i /><span>без выраженного форсирования;</span></div>
            <div className="svis-line"><i /><span>в различных динамических режимах;</span></div>
            <div className="svis-line"><i /><span>внутри музыкальной фразы;</span></div>
            <div className="svis-line"><i /><span>в профессиональном репертуаре;</span></div>
            <p>Основная работа SVIS направлена на последовательное преобразование потенциального диапазона в функциональный.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major svis-principles-heading">
        <div className="svis-section__body">
          <h2>Три фундаментальных принципа SVIS</h2>
          <div className="svis-copy">

          </div>
        </div>
      </section>

      <section className="svis-section svis-section--detail svis-section--principle">
        <div className="svis-section__body">
          <h2>I. Регистровая интеграция</h2>
          <div className="svis-copy">
            <p>SVIS рассматривает вокальные регистры как взаимосвязанные формы функционирования единого голосового аппарата.</p>
            <p>Задача методики заключается не в изолированном развитии отдельных регистров, а в создании устойчивой координации между ними.</p>
            <p>В процессе обучения формируются:</p>
            <div className="svis-line"><i /><span>плавность регистровых переходов;</span></div>
            <div className="svis-line"><i /><span>устойчивость голосовой координации;</span></div>
            <div className="svis-line"><i /><span>контроль интенсивности звука;</span></div>
            <div className="svis-line"><i /><span>согласованность дыхательной и фонаторной функции;</span></div>
            <div className="svis-line"><i /><span>возможность переходить через различные участки диапазона без резких изменений качества звука;</span></div>
            <div className="svis-line"><i /><span>способность сохранять художественную целостность вокальной линии;</span></div>

            <p>Особое внимание уделяется формированию устойчивой координации в переходных зонах голоса.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--detail svis-section--principle">
        <div className="svis-section__body">
          <h2>II. Управляемое расширение диапазона</h2>
          <div className="svis-copy">
            <p>В SVIS увеличение диапазона происходит исключительно поэтапно.</p>
            <p>Новая нота первоначально рассматривается не как достигнутый результат, а как новая функциональная зона, которая должна пройти последовательные этапы стабилизации.</p>
            <p>Исполнитель сначала получает технический доступ к новой ноте, затем закрепляет ее, учится соединять с соседними звуками и только после этого переносит в музыкальный материал.</p>
            <p>Такой принцип позволяет избегать ситуации, когда крайние ноты существуют отдельно от основного голоса и не могут полноценно использоваться в исполнении.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--detail svis-section--principle">
        <div className="svis-section__body">
          <h2>III. Сохранение индивидуального тембра</h2>
          <div className="svis-copy">
            <p>SVIS не стремится привести голоса разных исполнителей к единому акустическому шаблону.</p>
            <p>Одна из задач системы — сохранить тембральную идентичность певца при развитии нового участка диапазона.</p>
            <p>В процессе обучения проводится отдельная работа над тем, чтобы расширение диапазона не сопровождалось резким изменением индивидуальной окраски голоса.</p>
            <p>Приоритетными являются:</p>
            <div className="svis-line"><i /><span>естественность звучания;</span></div>
            <div className="svis-line"><i /><span>тембральная связность диапазона;</span></div>
            <div className="svis-line"><i /><span>индивидуальность исполнителя;</span></div>
            <div className="svis-line"><i /><span>динамическая свобода;</span></div>
            <div className="svis-line"><i /><span>жанровая идентичность;</span></div>
            <div className="svis-line"><i /><span>художественная выразительность;</span></div>
          </div>
        </div>
      </section>

      <section className="svis-toolkit" aria-labelledby="svis-toolkit-title">
        <header className="svis-toolkit__header">
          <span>Диагностика · Картирование · Динамика</span>
          <h2 id="svis-toolkit-title">Инструменты измерения SVIS</h2>
          <p>Три взаимосвязанных инструмента формируют единую систему диагностики, построения функциональной карты голоса и объективной оценки прогресса.</p>
        </header>
        <div className="svis-toolkit__tabs" role="tablist" aria-label="Инструменты SVIS">
          <button type="button" role="tab" aria-selected={activeTool === "profile"} className={activeTool === "profile" ? "is-active" : ""} onClick={() => setActiveTool("profile")}>
            <b>01</b>
            <span>SVIS Vocal Profile Assessment</span>
            <i>Диагностика</i>
          </button>
          <button type="button" role="tab" aria-selected={activeTool === "range"} className={activeTool === "range" ? "is-active" : ""} onClick={() => setActiveTool("range")}>
            <b>02</b>
            <span>SVIS Vocal Range Map</span>
            <i>Карта диапазона</i>
          </button>
          <button type="button" role="tab" aria-selected={activeTool === "progress"} className={activeTool === "progress" ? "is-active" : ""} onClick={() => setActiveTool("progress")}>
            <b>03</b>
            <span>SVIS Progress Index</span>
            <i>Оценка прогресса</i>
          </button>
        </div>
        <div className="svis-toolkit__panel" role="tabpanel">
          {activeTool === "profile" && <div className="svis-toolkit__content svis-toolkit__content--profile">
            <h3>SVIS Vocal Profile Assessment</h3>
            <div className="svis-copy">
              <p>Первичная функциональная диагностика голоса</p>
              <p>Работа по системе начинается с SVIS Vocal Profile Assessment — стандартизированной первичной оценки функциональных характеристик певческого голоса.</p>
              <p>Диагностика позволяет определить исходную точку обучения и сформировать индивидуальную стратегию развития.</p>
              <p>Оцениваются семь основных параметров.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>1. Рабочий диапазон</span>
              </div>
              <p>Определяются:</p>
              <div className="svis-line">
                <i />
                <span>нижняя граница устойчивого диапазона;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>верхняя граница устойчивого диапазона;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>максимальный потенциальный диапазон;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>ноты, доступные только эпизодически;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>зоны функциональной нестабильности;</span>
              </div>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>2. Регистровая структура</span>
              </div>
              <p>Определяются индивидуальные участки, в которых происходят наиболее заметные изменения голосовой координации.</p>
              <p>Фиксируются:</p>
              <div className="svis-line">
                <i />
                <span>переходные зоны;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>изменение плотности звучания;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>изменение характера атаки;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>появление нестабильности;</span>
              </div>
               <div className="svis-line">
                <i />
                <span>изменения тембрального баланса;</span>
              </div>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>3. Интонационный контроль</span>
              </div>
              <p>Оценивается способность исполнителя:</p>
              <div className="svis-line">
                <i />
                <span>точно начинать звук;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>удерживать заданную высоту;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>сохранять интонацию при движении по диапазону;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>точно выполнять интервальные последовательности;</span>
              </div>

              <div className="svis-line svis-line--criterion">
                <i />
                <span>4. Тембральная связность</span>
              </div>
              <p>Анализируется характер изменения тембра при движении от нижнего к верхнему участку диапазона.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>5. Динамический контроль</span>
              </div>
              <p>Определяется способность исполнителя сохранять стабильность голосовой координации при изменении интенсивности звука.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>6. Координационная устойчивость</span>
              </div>
              <p>Анализируется повторяемость вокального результата и способность сохранять выбранную координацию в серии упражнений.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>7. Репертуарная функциональность</span>
              </div>
              <p>Определяется, какие участки формального диапазона певец действительно способен использовать в полноценном музыкальном исполнении.</p>
            </div>
          </div>}
          {activeTool === "range" && <div className="svis-toolkit__content svis-toolkit__content--range">
            <h3>SVIS Vocal Range Map</h3>
            <div className="svis-copy">
              <p>По итогам диагностики формируется индивидуальная SVIS Vocal Range Map — функциональная карта вокального диапазона.</p>
              <p>Диапазон разделяется на четыре зоны.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>Зона A — Functional Core</span>
              </div>
              <p>Стабильное функциональное ядро голоса.</p>
              <p>Здесь исполнитель демонстрирует устойчивое качество звучания, свободно использует ноты в репертуаре и способен управлять динамикой, артикуляцией и музыкальной фразировкой.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>Зона B — Integration Zone</span>
              </div>
              <p>Зона регистровой интеграции.</p>
              <p>Ноты доступны исполнителю, но требуют дополнительной координации. Именно здесь наиболее часто проявляются изменения тембра, интенсивности или характера голосообразования.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>Зона C — Expansion Zone</span>
              </div>
              <p>Зона контролируемого расширения.</p>
              <p>Ноты уже доступны в специализированных упражнениях, однако еще не соответствуют критериям устойчивого рабочего диапазона.</p>
              <div className="svis-line svis-line--criterion">
                <i />
                <span>Зона D — Potential Zone</span>
              </div>
              <p>Потенциальная зона.</p>
              <p>Ноты появляются эпизодически, но пока не являются управляемыми и не используются в профессиональном исполнении.</p>
              <p>Главная задача программы — постепенно переводить участки диапазона:</p>
              <div className="svis-flow">D → C → B → A.</div>
              <p>Таким образом, расширение диапазона становится контролируемым и измеряемым процессом.</p>
            </div>
          </div>}
          {activeTool === "progress" && <div className="svis-toolkit__content svis-toolkit__content--progress">
            <h3>SVIS Progress Index</h3>
            <div className="svis-copy">
              <p>Система объективной оценки прогресса</p>
              <p>SVIS включает собственную систему мониторинга — SVIS Progress Index.</p>
              <p>Каждый ключевой параметр оценивается по единой шкале и фиксируется в индивидуальной карте исполнителя.</p>
              <p>Оцениваются:</p>
              <div className="svis-line">
                <i />
                <span>функциональный диапазон;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>регистровая интеграция;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>интонационная стабильность;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>тембральная связность;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>динамический контроль;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>координационная устойчивость;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>перенос техники в репертуар;</span>
              </div>              

              <p>Диагностика проводится:</p>
              <div className="svis-line">
                <i />
                <span>в начале программы;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>после каждого ключевого этапа;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>по завершении основного цикла;</span>
              </div>
              <div className="svis-line">
                <i />
                <span>во время контрольного периода закрепления результата;</span>
              </div>              

              <p>Такой подход позволяет преподавателю видеть не только субъективное улучшение звучания, но и конкретную динамику развития отдельных параметров.</p>
            </div>
          </div>}
        </div>
      </section>

      <section className="svis-section svis-section--major svis-tool-source">
        <div className="svis-section__body">
          <h2>SVIS Vocal Profile Assessment</h2>
          <div className="svis-copy">
            <p>Первичная функциональная диагностика голоса</p>
            <p>Работа по системе начинается с SVIS Vocal Profile Assessment — стандартизированной первичной оценки функциональных характеристик певческого голоса.</p>
            <p>Диагностика позволяет определить исходную точку обучения и сформировать индивидуальную стратегию развития.</p>
            <p>Оцениваются семь основных параметров.</p>
<div className="svis-line svis-line--criterion"><i /><span>1. Рабочий диапазон</span></div>
            <p>Определяются:</p>
            <div className="svis-line"><i /><span>нижняя граница устойчивого диапазона;</span></div>
            <div className="svis-line"><i /><span>верхняя граница устойчивого диапазона;</span></div>
            <div className="svis-line"><i /><span>максимальный потенциальный диапазон;</span></div>
            <div className="svis-line"><i /><span>ноты, доступные только эпизодически;</span></div>
            <p>зоны функциональной нестабильности.</p>
<div className="svis-line svis-line--criterion"><i /><span>2. Регистровая структура</span></div>
            <p>Определяются индивидуальные участки, в которых происходят наиболее заметные изменения голосовой координации.</p>
            <p>Фиксируются:</p>
            <div className="svis-line"><i /><span>переходные зоны;</span></div>
            <div className="svis-line"><i /><span>изменение плотности звучания;</span></div>
            <div className="svis-line"><i /><span>изменение характера атаки;</span></div>
            <div className="svis-line"><i /><span>появление нестабильности;</span></div>
            <p>изменения тембрального баланса.</p>
<div className="svis-line svis-line--criterion"><i /><span>3. Интонационный контроль</span></div>
            <p>Оценивается способность исполнителя:</p>
            <div className="svis-line"><i /><span>точно начинать звук;</span></div>
            <div className="svis-line"><i /><span>удерживать заданную высоту;</span></div>
            <div className="svis-line"><i /><span>сохранять интонацию при движении по диапазону;</span></div>
            <p>точно выполнять интервальные последовательности.</p>
<div className="svis-line svis-line--criterion"><i /><span>4. Тембральная связность</span></div>
            <p>Анализируется характер изменения тембра при движении от нижнего к верхнему участку диапазона.</p>
<div className="svis-line svis-line--criterion"><i /><span>5. Динамический контроль</span></div>
            <p>Определяется способность исполнителя сохранять стабильность голосовой координации при изменении интенсивности звука.</p>
<div className="svis-line svis-line--criterion"><i /><span>6. Координационная устойчивость</span></div>
            <p>Анализируется повторяемость вокального результата и способность сохранять выбранную координацию в серии упражнений.</p>
<div className="svis-line svis-line--criterion"><i /><span>7. Репертуарная функциональность</span></div>
            <p>Определяется, какие участки формального диапазона певец действительно способен использовать в полноценном музыкальном исполнении.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major svis-tool-source">
        <div className="svis-section__body">
          <h2>SVIS Vocal Range Map</h2>
          <div className="svis-copy">
            <p>По итогам диагностики формируется индивидуальная SVIS Vocal Range Map — функциональная карта вокального диапазона.</p>
            <p>Диапазон разделяется на четыре зоны.</p>
            <div className="svis-line"><i /><span>Зона A — Functional Core</span></div>
            <p>Стабильное функциональное ядро голоса.</p>
            <p>Здесь исполнитель демонстрирует устойчивое качество звучания, свободно использует ноты в репертуаре и способен управлять динамикой, артикуляцией и музыкальной фразировкой.</p>
            <div className="svis-line"><i /><span>Зона B — Integration Zone</span></div>
            <p>Зона регистровой интеграции.</p>
            <p>Ноты доступны исполнителю, но требуют дополнительной координации. Именно здесь наиболее часто проявляются изменения тембра, интенсивности или характера голосообразования.</p>
            <div className="svis-line"><i /><span>Зона C — Expansion Zone</span></div>
            <p>Зона контролируемого расширения.</p>
            <p>Ноты уже доступны в специализированных упражнениях, однако еще не соответствуют критериям устойчивого рабочего диапазона.</p>
            <div className="svis-line"><i /><span>Зона D — Potential Zone</span></div>
            <p>Потенциальная зона.</p>
            <p>Ноты появляются эпизодически, но пока не являются управляемыми и не используются в профессиональном исполнении.</p>
            <p>Главная задача программы — постепенно переводить участки диапазона:</p>
            <div className="svis-flow">D → C → B → A.</div>
            <p>Таким образом, расширение диапазона становится контролируемым и измеряемым процессом.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major" id="structure">
        <div className="svis-section__body">
          <h2>Структура методики SVIS</h2>
          <div className="svis-copy">
            <p>Методика включает семь последовательных этапов.</p>
          </div>
        </div>
      </section>

      <details className="svis-module" open={openModule === "Модуль I. Functional Voice Stabilization"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль I. Functional Voice Stabilization"); }}>
          <span>I</span><div><b>Модуль I. Functional Voice Stabilization</b><small>Функциональная стабилизация голоса</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>Первый этап формирует устойчивую базовую координацию.</p>
          <p>До начала расширения диапазона необходимо добиться стабильности голоса в уже доступном участке.</p>
          <p>Работа направлена на:</p>
          <div className="svis-line"><i /><span>формирование контролируемой атаки;</span></div>
          <div className="svis-line"><i /><span>стабилизацию средней части диапазона;</span></div>
          <div className="svis-line"><i /><span>согласование дыхания и фонации;</span></div>
          <div className="svis-line"><i /><span>снижение избыточного мышечного усилия;</span></div>
          <div className="svis-line"><i /><span>развитие сенсорного контроля;</span></div>
          <div className="svis-line"><i /><span>формирование устойчивого повторяемого звучания;</span></div>
          <p>Применяются упражнения на плавную фонацию, вокальные скольжения, губные и языковые трели, резонансные упражнения и последовательности с частичным сужением вокального тракта.</p>
          <p>Результатом первого модуля становится формирование стабильной исходной платформы, на которой строится последующая работа.</p>
        </div>
      </details>

      <details className="svis-module" open={openModule === "Модуль II. Register Identification"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль II. Register Identification"); }}>
          <span>II</span><div><b>Модуль II. Register Identification</b><small>Определение регистровых переходов</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>На втором этапе исполнитель учится распознавать индивидуальное поведение собственного голоса в переходных участках.</p>
          <p>Работа направлена на развитие осознанного контроля над:</p>
          <div className="svis-line"><i /><span>изменением плотности звука;</span></div>
          <div className="svis-line"><i /><span>ощущением регистрового перехода;</span></div>
          <div className="svis-line"><i /><span>динамикой;</span></div>
          <div className="svis-line"><i /><span>изменением тембра;</span></div>
          <div className="svis-line"><i /><span>появлением избыточного давления;</span></div>
          <div className="svis-line"><i /><span>изменением положения артикуляционного аппарата;</span></div>
          <div className="svis-line"><i /><span>реакцией голоса на движение вверх и вниз;</span></div>         
          <p>Главная задача — сделать переходную зону управляемой и предсказуемой.</p>
        </div>
      </details>

      <details className="svis-module" open={openModule === "Модуль III. Register Decompression"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль III. Register Decompression"); }}>
          <span>III</span><div><b>Модуль III. Register Decompression</b><small>Регистровая декомпрессия</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>На этом этапе снижается зависимость исполнителя от дополнительного усилия при движении к верхнему участку диапазона.</p>
          <p>Работа проводится посредством:</p>
          <div className="svis-line"><i /><span>плавных восходящих и нисходящих последовательностей;</span></div>
          <div className="svis-line"><i /><span>интервальных упражнений;</span></div>
          <div className="svis-line"><i /><span>арпеджио;</span></div>
          <div className="svis-line"><i /><span>глиссандо;</span></div>
          <div className="svis-line"><i /><span>адаптации гласных;</span></div>
          <div className="svis-line"><i /><span>изменения интенсивности звука;</span></div>
          <div className="svis-line"><i /><span>упражнений на сохранение баланса между воздушным потоком и голосовой координацией;</span></div>          

          <p>Задача модуля — сформировать способность повышать высоту звука посредством изменения координации, а не простого увеличения физического усилия.</p>
        </div>
      </details>

      <details className="svis-module" open={openModule === "Модуль IV. SVIS Register Bridge Protocol"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль IV. SVIS Register Bridge Protocol"); }}>
          <span>IV</span><div><b>Модуль IV. SVIS Register Bridge Protocol</b><small>Протокол интеграции переходной зоны</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>SVIS Register Bridge Protocol является одним из центральных элементов системы.</p>
          <p>Переходная зона рассматривается как самостоятельный объект тренировки.</p>
          <p>Работа проводится вокруг конкретного регистрового перехода:</p>
          <div className="svis-flow">стабильная нота → переходная зона → новая нота → обратное возвращение в устойчивую зону.</div>
          <p>После достижения стабильности диапазон упражнения постепенно расширяется.</p>
          <p>Это позволяет сформировать устойчивую связь между различными участками голоса.</p>
          <p>В результате переход перестает восприниматься как технический барьер и превращается в функциональный мост между регистрами.</p>
        </div>
      </details>

      <details className="svis-module" open={openModule === "Модуль V. Controlled Range Expansion"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль V. Controlled Range Expansion"); }}>
          <span>V</span><div><b>Модуль V. Controlled Range Expansion</b><small>Управляемое расширение диапазона</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>После стабилизации переходных зон начинается непосредственное увеличение функционального диапазона.</p>
          <p>Основой данного этапа является авторский принцип Adjacent Note Acquisition — последовательного присоединения новой ноты.</p>
          <p>Расширение происходит не путем многократной попытки достичь предельно высокой или низкой ноты.</p>
          <p>Каждая новая нота сначала вводится как отдельный функциональный элемент, затем стабилизируется и интегрируется в существующий диапазон.</p>
          <p>Последовательность выглядит следующим образом:</p>
          <div className="svis-flow">доступ к новой ноте → стабилизация → соединение с соседними нотами → динамический контроль → тембральная интеграция → музыкальное применение.</div>
          <p>Только после завершения этого цикла начинается освоение следующего участка диапазона.</p>
        </div>
      </details>

      <details className="svis-module" open={openModule === "Модуль VI. Timbre Preservation Protocol"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль VI. Timbre Preservation Protocol"); }}>
          <span>VI</span><div><b>Модуль VI. Timbre Preservation Protocol</b><small>Протокол сохранения тембральной идентичности</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>Техническая доступность новой ноты еще не означает завершения процесса.</p>
          <p>После ее стабилизации начинается отдельный этап тембральной интеграции.</p>
          <p>В рамках SVIS Timbre Preservation Protocol исполнитель учится сохранять индивидуальный характер голоса при изменении высоты.</p>
          <p>Проводится работа над:</p>
          <div className="svis-line"><i /><span>акустическим балансом;</span></div>
          <div className="svis-line"><i /><span>артикуляцией;</span></div>
          <div className="svis-line"><i /><span>формированием гласных;</span></div>
          <div className="svis-line"><i /><span>резонансной настройкой;</span></div>
          <div className="svis-line"><i /><span>динамикой;</span></div>
          <div className="svis-line"><i /><span>характером атаки;</span></div>
          <div className="svis-line"><i /><span>связностью вокальной линии;</span></div>
          <p>Задача состоит в том, чтобы слушатель воспринимал различные участки диапазона как единый голос одного исполнителя, а не как несколько разрозненных вокальных механизмов.</p>
        </div>
      </details>

      <details className="svis-module" open={openModule === "Модуль VII. Performance Integration Protocol"}>
        <summary onClick={(event) => { event.preventDefault(); setOpenModule("Модуль VII. Performance Integration Protocol"); }}>
          <span>VII</span><div><b>Модуль VII. Performance Integration Protocol</b><small>Перенос навыка в профессиональное исполнение</small></div><i>+</i>
        </summary>
        <div className="svis-copy">
          <p>Завершающий этап SVIS посвящен переносу сформированной техники в музыкальный материал.</p>
          <p>Работа строится в следующей последовательности:</p>
          <div className="svis-flow">техническое упражнение → вокализ → короткая музыкальная фраза → фрагмент произведения → полное произведение → сценическое исполнение.</div>
          <p>На каждом этапе оценивается способность сохранять новую вокальную координацию.</p>
          <p>Особое внимание уделяется условиям, характерным для профессионального выступления:</p>
          <div className="svis-line"><i /><span>эмоциональной интенсивности;</span></div>
          <div className="svis-line"><i /><span>изменению динамики;</span></div>
          <div className="svis-line"><i /><span>движению на сцене;</span></div>
          <div className="svis-line"><i /><span>работе с микрофоном;</span></div>
          <div className="svis-line"><i /><span>различным акустическим условиям;</span></div>
          <div className="svis-line"><i /><span>продолжительному исполнению;</span></div>
          <div className="svis-line"><i /><span>концертной нагрузке;</span></div>
          <p>Цель — сделать технический результат исполнительским навыком, который сохраняется не только в классе, но и на сцене.</p>
        </div>
      </details>

            <section className="svis-section svis-section--detail svis-section--principle">
        <div className="svis-section__body">
          <h2>SVIS Five-Point Stability Test</h2>
          <div className="svis-copy">
            <p>Пятикомпонентный тест функциональной стабильности</p>
            <p>Каждая новая нота проходит обязательную оценку по пяти критериям.</p>
            <div className="svis-line"><i /><span>1. Repeatability — повторяемость</span></div>
            <p>Нота должна воспроизводиться последовательно и с сопоставимым качеством.</p>
            <div className="svis-line"><i /><span>2. Intonation — интонационная стабильность</span></div>
            <p>Исполнитель должен точно достигать и удерживать необходимую высоту.</p>
            <div className="svis-line"><i /><span>3. Timbre — тембральная целостность</span></div>
            <p>Новая нота должна сохранять акустическую и художественную связь с основным голосом.</p>
            <div className="svis-line"><i /><span>4. Connection — регистровая связность</span></div>
            <p>Нота должна свободно соединяться с предыдущим и последующим участками диапазона.</p>
            <div className="svis-line"><i /><span>5. Musical Transfer — музыкальный перенос</span></div>
            <p>Нота должна использоваться не только в техническом упражнении, но и в реальной музыкальной фразе.</p>
            <p>Только после выполнения всех пяти условий новая нота переводится из Expansion Zone в функциональный рабочий диапазон.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major svis-tool-source">
        <div className="svis-section__body">
          <h2>SVIS Progress Index</h2>
          <div className="svis-copy">
            <p>Система объективной оценки прогресса</p>
            <p>SVIS включает собственную систему мониторинга — SVIS Progress Index.</p>
            <p>Каждый ключевой параметр оценивается по единой шкале и фиксируется в индивидуальной карте исполнителя.</p>
            <p>Оцениваются:</p>
            <div className="svis-line"><i /><span>функциональный диапазон;</span></div>
            <div className="svis-line"><i /><span>регистровая интеграция;</span></div>
            <div className="svis-line"><i /><span>интонационная стабильность;</span></div>
            <div className="svis-line"><i /><span>тембральная связность;</span></div>
            <div className="svis-line"><i /><span>динамический контроль;</span></div>
            <div className="svis-line"><i /><span>координационная устойчивость;</span></div>
            <p>перенос техники в репертуар.</p>
            <p>Диагностика проводится:</p>
            <div className="svis-line"><i /><span>в начале программы;</span></div>
            <div className="svis-line"><i /><span>после каждого ключевого этапа;</span></div>
            <div className="svis-line"><i /><span>по завершении основного цикла;</span></div>
            <p>во время контрольного периода закрепления результата.</p>
            <p>Такой подход позволяет преподавателю видеть не только субъективное улучшение звучания, но и конкретную динамику развития отдельных параметров.</p>
          </div>
        </div>
      </section>

      <section className="svis-training">
        <header className="svis-training__header">
          <div className="svis-training__heading">
            <span>Персональный маршрут · SVIS</span>
            <h2>От индивидуальной архитектуры к профессиональной практике</h2>
          </div>
          <div className="svis-training__route" aria-hidden="true">
            <div className="svis-training__track"><i /></div>
            <div className="svis-training__nodes"><b>Голос</b><b>Техника</b><b>Сцена</b><b>Педагог</b></div>
            <div className="svis-training__wave">{[32,58,84,46,72,95,61,38,78,52].map((height, index) => <i key={index} style={{ "--training-wave": `${height}%`, "--training-index": index }} />)}</div>
          </div>
        </header>
        <div className="svis-training__chapters">
      <section className="svis-section svis-section--major svis-training__chapter">
        <div className="svis-section__body">
          <h2>Индивидуальная архитектура обучения</h2>
          <div className="svis-copy">
            <p>SVIS не использует универсальную последовательность упражнений для всех исполнителей.</p>
            <p>Для каждого вокалиста формируется Individual SVIS Training Path — индивидуальный маршрут подготовки.</p>
            <p>Он учитывает:</p>
            <div className="svis-line"><i /><span>исходный диапазон;</span></div>
            <div className="svis-line"><i /><span>тип голоса;</span></div>
            <div className="svis-line"><i /><span>характер переходных зон;</span></div>
            <div className="svis-line"><i /><span>уровень профессиональной подготовки;</span></div>
            <div className="svis-line"><i /><span>жанровую специализацию;</span></div>
            <div className="svis-line"><i /><span>особенности тембра;</span></div>
            <div className="svis-line"><i /><span>текущие технические задачи;</span></div>
            <div className="svis-line"><i /><span>профессиональный репертуар;</span></div>
            <div className="svis-line"><i /><span>сценическую нагрузку;</span></div>
            <p>Таким образом, SVIS представляет собой не набор готовых вокальных упражнений, а диагностико-педагогическую систему принятия решений, которая позволяет преподавателю адаптировать методику к конкретному голосу.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major svis-training__chapter">
        <div className="svis-section__body">
          <h2>Работа с профессиональным репертуаром</h2>
          <div className="svis-copy">
            <p>Репертуар является обязательной частью системы.</p>
            <p>Каждый новый технический навык должен пройти три стадии:</p>
            <p>Technical Acquisition — освоение координации в упражнении.</p>
            <p>Musical Integration — использование координации в музыкальной фразе.</p>
            <p>Performance Stabilization — сохранение навыка в полноценном сценическом исполнении.</p>
            <p>Это позволяет устранить разрыв между «голосом на уроке» и «голосом на сцене».</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major svis-training__chapter">
        <div className="svis-section__body">
          <h2>Работа с преподавателями вокала</h2>
          <div className="svis-copy">
            <p>Отдельным направлением SVIS является подготовка преподавателей, способных самостоятельно применять систему в профессиональной образовательной практике.</p>
            <p>SVIS Teacher Training Program</p>
            <p>Программа включает четыре уровня.</p>
            <div className="svis-line svis-line--criterion"><i /><span>Level I — SVIS Foundations</span></div>
            <p>Изучаются:</p>
            <div className="svis-line"><i /><span>концепция функционального диапазона;</span></div>
            <div className="svis-line"><i /><span>принципы регистровой интеграции;</span></div>
            <div className="svis-line"><i /><span>основы первичной диагностики;</span></div>
            <div className="svis-line"><i /><span>проведение SVIS Vocal Profile Assessment;</span></div>
            <div className="svis-line"><i /><span>составление SVIS Vocal Range Map;</span></div>
            <div className="svis-line svis-line--criterion"><i /><span>Level II — Register Integration</span></div>
            <p>Изучаются:</p>
            <div className="svis-line"><i /><span>анализ переходных зон;</span></div>
            <div className="svis-line"><i /><span>SVIS Register Bridge Protocol;</span></div>
            <div className="svis-line"><i /><span>регистровая декомпрессия;</span></div>
            <div className="svis-line"><i /><span>адаптация упражнений под индивидуальный голос;</span></div>
            <div className="svis-line"><i /><span>выявление технических компенсаций;</span></div>
            <div className="svis-line svis-line--criterion"><i /><span>Level III — Controlled Range Expansion</span></div>
            <p>Изучаются:</p>
            <div className="svis-line"><i /><span>Adjacent Note Acquisition;</span></div>
            <div className="svis-line"><i /><span>SVIS Five-Point Stability Test;</span></div>
            <div className="svis-line"><i /><span>перевод ноты из потенциального в функциональный диапазон;</span></div>
            <div className="svis-line"><i /><span>ведение SVIS Progress Index;</span></div>
            <div className="svis-line"><i /><span>формирование индивидуального маршрута обучения;</span></div>
            <div className="svis-line svis-line--criterion"><i /><span>Level IV — Professional Application</span></div>
            <p>Заключительный уровень включает:</p>
            <div className="svis-line"><i /><span>работу с профессиональными исполнителями;</span></div>
            <div className="svis-line"><i /><span>адаптацию SVIS к различным вокальным стилям;</span></div>
            <div className="svis-line"><i /><span>репертуарную интеграцию;</span></div>
            <div className="svis-line"><i /><span>анализ сложных педагогических случаев;</span></div>
            <div className="svis-line"><i /><span>планирование долгосрочной программы развития;</span></div>
            <div className="svis-line"><i /><span>практическую аттестацию преподавателя;</span></div>
          </div>
        </div>
      </section>
        </div>
      </section>

      <section className="svis-section svis-section--major">
        <div className="svis-section__body">
          <h2>Применение SVIS в образовательных учреждениях</h2>
          <div className="svis-copy">
            <p>Методика разработана таким образом, чтобы использоваться как в индивидуальной педагогической практике, так и в системном музыкальном образовании.</p>
            <p>SVIS может интегрироваться в:</p>
            <div className="svis-line"><i /><span>программы подготовки профессиональных вокалистов;</span></div>
            <div className="svis-line"><i /><span>курсы сольного пения;</span></div>
            <div className="svis-line"><i /><span>программы эстрадного и джазового вокала;</span></div>
            <div className="svis-line"><i /><span>программы музыкального театра;</span></div>
            <div className="svis-line"><i /><span>программы дополнительной профессиональной подготовки;</span></div>
            <div className="svis-line"><i /><span>повышение квалификации преподавателей;</span></div>
            <div className="svis-line"><i /><span>методические семинары для педагогов;</span></div>
            <div className="svis-line"><i /><span>специализированные модули вокальной техники;</span></div>
            <p>Система позволяет использовать единый понятийный аппарат, общие критерии оценки и стандартную систему фиксации прогресса, сохраняя возможность индивидуальной адаптации программы к каждому исполнителю.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major">
        <div className="svis-section__body">
          <h2>Основные авторские компоненты SVIS</h2>
          <div className="svis-copy">
            <p>Целостную архитектуру Stepanova Vocal Integration System формируют восемь взаимосвязанных инструментов:</p>
            <p>SVIS Vocal Profile Assessment — система первичной функциональной диагностики.</p>
            <p>SVIS Vocal Range Map — карта функциональных зон диапазона.</p>
            <p>SVIS Register Bridge Protocol — алгоритм интеграции переходных участков.</p>
            <p>Adjacent Note Acquisition — принцип последовательного присоединения новых нот.</p>
            <p>SVIS Five-Point Stability Test — система определения функциональной стабильности новой ноты.</p>
            <p>SVIS Timbre Preservation Protocol — система тембральной интеграции расширенного диапазона.</p>
            <p>SVIS Performance Integration Protocol — алгоритм переноса навыка в музыкальное и сценическое исполнение.</p>
            <p>SVIS Progress Index — система стандартизированного мониторинга профессионального прогресса.</p>
            <p>Именно взаимодействие этих компонентов превращает SVIS в единую воспроизводимую методическую систему.</p>
          </div>
        </div>
      </section>

      <section className="svis-section svis-section--major">
        <div className="svis-section__body">
          <h2>Результат работы по системе SVIS</h2>
          <div className="svis-copy">
            <p>Целью обучения является формирование вокалиста, который способен:</p>
            <div className="svis-line"><i /><span>свободно управлять функциональным диапазоном;</span></div>
            <div className="svis-line"><i /><span>уверенно проходить регистровые переходы;</span></div>
            <div className="svis-line"><i /><span>использовать расширенный диапазон в репертуаре;</span></div>
            <div className="svis-line"><i /><span>сохранять индивидуальный тембр;</span></div>
            <div className="svis-line"><i /><span>управлять динамикой;</span></div>
            <div className="svis-line"><i /><span>сохранять интонационную стабильность;</span></div>
            <div className="svis-line"><i /><span>адаптировать голос к различным исполнительским задачам;</span></div>
            <div className="svis-line"><i /><span>переносить сформированную технику в сценическую практику;</span></div>
            <p>Главным показателем результата является не количество освоенных крайних нот само по себе, а расширение устойчивого, музыкально применимого профессионального диапазона исполнителя.</p>
          </div>
        </div>
      </section>

      <section className="svis-philosophy">
        <span>Манифест</span>
        <h2>Философия SVIS</h2>
        <div className="svis-copy">
          <p>Голос не должен преодолевать диапазон. Он должен научиться существовать в нем свободно.</p>
          <p>SVIS рассматривает вокальное развитие как процесс последовательного формирования новых координаций, при котором каждая новая нота становится не техническим достижением, а полноценной частью исполнительского инструмента.</p>
          <p>Задача преподавателя состоит не в том, чтобы заставить голос соответствовать заранее заданной модели, а в том, чтобы раскрыть его индивидуальный функциональный потенциал, сохранив естественную тембральную идентичность артиста.</p>
          <p>Именно поэтому центральная идея Stepanova Vocal Integration System заключается в трех понятиях:</p>
          <p>Integration. Control. Individuality.</p>
          <p> Интеграция. Управление. Индивидуальность.</p>
          <p>Эти принципы определяют весь процесс подготовки — от первой диагностики до профессионального сценического исполнения.</p>
        </div>
      </section>
    </>
  );
}

function App() {
  const [openModule, setOpenModule] = useState("Модуль I. Functional Voice Stabilization");
  const [formStatus, setFormStatus] = useState("");

  const handleContactSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    const name = new FormData(form).get("name");
    form.reset();
    setFormStatus(`Спасибо, ${name}! Ваше сообщение принято. Мы свяжемся с вами в ближайшее время.`);
  };


  return (
    <main className="svis-site">
      <nav className="svis-nav">
        <a className="svis-logo" href="#top"><b>SVIS</b><span>Stepanova Vocal Integration System</span></a>
        <div className="svis-nav__links">
          <a href="#history">История</a>
          <a href="#impact">Влияние</a>
          <a href="#scale">Масштаб</a>
          <a href="#method">Методика</a>
          <a href="#structure">Модули</a>
          <a href="#tuition">Стоимость</a>
          <a href="#reviews">Отзывы</a>
        </div>
        <a className="svis-nav__cta" href="#contact">Связаться</a>
      </nav>

            <header className="svis-hero" id="top">
        <div className="svis-hero__copy">
          <div className="svis-kicker">Integration · Control · Individuality</div>
          <h1>Stepanova Vocal Integration System (SVIS)</h1>
          <h2>Методика регистровой интеграции и управляемого расширения вокального диапазона</h2>
          <div className="svis-authorline">Автор: Татьяна Степанова</div>
          <p>Заслуженная артистка Украины, лауреат международных вокальных конкурсов, профессиональная певица, вокальный педагог и автор методики SVIS.</p>
          <a className="svis-button" href="#method">Изучить методику <span>↘</span></a>
        </div>
        <div className="svis-hero__visual" aria-hidden="true">
          <div className="svis-orbit svis-orbit--one" />
          <div className="svis-orbit svis-orbit--two" />
          <div className="svis-wave">{[18,34,54,76,46,88,62,38,72,94,56,30,48,82,66,40].map((h, i) => <i key={i} style={{height: `${h}%`}} />)}</div>
          <div className="svis-visual__word">VOICE<br/><em>IN MOTION</em></div>
        </div>
      </header>

      <section className="method-author" id="author">
        <div className="method-author__intro">
          <div className="method-author__index">Автор · SVIS</div>
          <h2>Об авторе методики</h2>
          <div className="method-author__portrait">
            <img src={authorPortrait} alt="Татьяна Степанова (TANA)" />
            <div className="method-author__signature">
              <span>Певица · Автор песен · Вокальный педагог</span>
              <strong>TANA</strong>
            </div>
          </div>
        </div>

        <div className="method-author__story">
          <div className="method-author__titleline">
            
            <h3>Татьяна Степанова (TANA)</h3>
          </div>
          <div className="method-author__text">
            <p className="method-author__lead">Татьяна Степанова (TANA) — известная украинская певица, автор песен, вокальный педагог, специалист в области современной вокальной подготовки и основатель авторского педагогического направления в профессиональном вокальном искусстве.</p>
            <p className="method-author__award">Татьяна является обладателем почетного государственного звания «Заслуженная артистка Украины», лауреатом национальной музыкальной премии M1 Music Awards в номинации «Певица года», победителем и лауреатом международных вокальных конкурсов, членом международных профессиональных объединений в сфере искусства. Ее профессиональный авторитет также подтверждается неоднократными приглашениями в состав жюри международных вокальных фестивалей и конкурсов, где ей доверяется оценка мастерства других исполнителей. В первоначальном профессиональном досье Татьяны также зафиксированы международные конкурсные победы, государственное признание и работа в составе жюри профессиональных вокальных мероприятий.</p>
          </div>
        </div>

        <div className="method-author__columns">
              <div className="method-author__column">
                <p>За годы профессиональной деятельности Татьяна сформировала репутацию одного из заметных представителей современной украинской вокальной сцены. Ее исполнительское мастерство получило признание со стороны государственных институтов, музыкальной индустрии, профессионального сообщества и широкой аудитории.</p>
                <p>Особое место в профессиональной биографии Татьяны занимает ее признание музыкальным сообществом. Помимо исполнительских наград, она неоднократно приглашалась для оценки работы других вокалистов в качестве члена жюри международных конкурсов, что стало закономерным продолжением ее собственного исполнительского опыта и экспертной деятельности.</p>
              </div>
              <div className="method-author__column">
                <p>Ее карьера включает масштабную концертную деятельность, сольные гастрольные проекты, участие в национальных телевизионных музыкальных программах и выступления на ведущих концертных площадках Украины. Профессиональная деятельность Татьяны неоднократно освещалась крупными национальными средствами массовой информации. В первоначальном кейсе также представлены материалы о сольном туре, который посетили более 10 000 зрителей, и о выступлениях на крупных национальных площадках.</p>
                <p>Профессиональное образование Татьяны включает обучение в Эстрадно-джазовом колледже имени Гнесиных, Институте современного искусства, а также магистратуру Goldsmiths, University of London по программе Arts Administration &amp; Cultural Policy (Music Pathway). Сочетание профессионального музыкального образования, многолетнего сценического опыта и системного изучения современных подходов к обучению вокал</p>
              </div>
        </div>
      </section>

      <section className="svis-history" id="history">
        <header className="svis-history__header">
          <div className="svis-history__heading">
            <span>Архив · 2020–2025</span>
            <h2>История развития Stepanova Vocal Integration System (SVIS)</h2>
            <p>Разработка Stepanova Vocal Integration System (SVIS) стала результатом многолетней исполнительской, педагогической и исследовательской деятельности Татьяны Степановой. На протяжении нескольких лет методика последовательно развивалась: от авторской концепции профессиональной вокальной подготовки до системы, применяемой образовательными учреждениями, преподавателями и профессиональными исполнителями.</p>
          </div>
          <div className="svis-history__player" aria-hidden="true">
            <div className="svis-history__record"><b>SVIS</b><small>2020—2025</small></div>
            <i className="svis-history__needle" />
            <div className="svis-history__wave">{[35,62,88,48,74,95,55,78,42,68].map((height, index) => <i key={index} style={{ "--history-wave": `${height}%`, "--history-index": index }} />)}</div>
          </div>
        </header>

        <div className="svis-history__timeline">
          <article className="svis-history__event"><div className="svis-history__year">2020 <small>год</small></div><div><h3>Создание авторской методики</h3><p>В 2020 году Татьяна Степанова завершила разработку Методики регистровой интеграции и управляемого расширения вокального диапазона, объединив результаты многолетней исполнительской практики, педагогического опыта и анализа современных мировых подходов к развитию профессионального певческого голоса.</p><p>Именно в этот период была сформирована концепция Stepanova Vocal Integration System (SVIS), определены ее основные педагогические принципы, разработана структура методики, диагностические инструменты и алгоритмы последовательного развития вокального диапазона.</p><p>Были созданы ключевые компоненты системы, включая модель функциональной диагностики голоса, карту вокального диапазона SVIS Vocal Range Map, систему оценки профессионального прогресса SVIS Progress Index, а также авторские алгоритмы регистровой интеграции и управляемого расширения диапазона.</p></div></article>
          <article className="svis-history__event"><div className="svis-history__year">2021 <small>год</small></div><div><h3>Признание методики на профессиональном уровне</h3><p>В 2021 году разработанная Татьяной Степановой методика получила первое масштабное профессиональное признание.</p><p>Ассоциация деятелей искусств использовала Методику регистровой интеграции и управляемого расширения вокального диапазона в качестве методологической основы при разработке отраслевого стандарта подготовки вокалистов, рекомендованного образовательным учреждениям стран СНГ.</p><p>Это стало важным этапом развития системы, подтвердив возможность применения методики не только в рамках индивидуальной педагогической практики, но и при формировании единых профессиональных подходов к подготовке вокалистов.</p><p>Использование методики при разработке отраслевого стандарта открыло возможности для ее дальнейшего внедрения в деятельность музыкальных образовательных учреждений и профессионального педагогического сообщества.</p></div></article>
          <article className="svis-history__event"><div className="svis-history__year">2022 <small>год</small></div><div><h3>Начало внедрения в высшее музыкальное образование</h3><p>В 2022 году начался новый этап развития SVIS — применение методики в системе высшего музыкального образования.</p><p>Первые ведущие музыкальные академии и консерватории официально подтвердили использование авторской методики Татьяны Степановой в образовательной деятельности.</p><p>Методика стала использоваться при подготовке профессиональных вокалистов, развитии исполнительских навыков, работе с регистровой координацией и совершенствовании современных педагогических подходов в области вокального искусства.</p><p>Именно с этого периода SVIS начала развиваться как воспроизводимая образовательная система, предназначенная для применения не только автором, но и другими преподавателями профильных дисциплин.</p></div></article>
          <article className="svis-history__event"><div className="svis-history__year">2023 <small>год</small></div><div><h3>Международное распространение и подготовка преподавателей</h3><p>В 2023 году география применения Stepanova Vocal Integration System значительно расширилась.</p><p>К использованию методики присоединились новые образовательные учреждения, а сама система стала применяться не только при подготовке профессиональных исполнителей, но и в программах профессионального развития преподавателей вокального искусства.</p><p>Одним из ключевых направлений развития стало обучение преподавателей принципам SVIS, включая методы функциональной диагностики голоса, алгоритмы регистровой интеграции, систему оценки профессионального прогресса и принципы управляемого расширения вокального диапазона.</p><p>Благодаря этому методика начала распространяться через профессиональное педагогическое сообщество, позволяя преподавателям самостоятельно использовать разработанные инструменты в собственной образовательной практике.</p></div></article>
          <article className="svis-history__event"><div className="svis-history__year">2024–2025 <small>годы</small></div><div><h3>Развитие профессионального сообщества SVIS</h3><p>В 2024–2025 годах развитие Stepanova Vocal Integration System было направлено на дальнейшее расширение профессионального применения методики и совершенствование ее образовательной модели.</p><p>В этот период продолжилось внедрение отдельных модулей SVIS в образовательные программы музыкальных академий, консерваторий и специализированных учреждений дополнительного профессионального образования.</p><p>Расширилось количество преподавателей, прошедших подготовку по системе, увеличилось число профессиональных вокалистов, использующих методику в своей исполнительской практике, а также выросло количество образовательных программ, интегрировавших отдельные диагностические и педагогические инструменты SVIS.</p><p>Продолжилось сотрудничество с музыкальными академиями, профессиональными объединениями и экспертами в области вокального искусства, направленное на совершенствование методических материалов, развитие программ подготовки преподавателей и дальнейшее распространение современных подходов к профессиональному вокальному образованию.</p></div></article>
        </div>

        <div className="svis-history__today"><span>Сейчас</span><h3>SVIS сегодня</h3><p>Сегодня Stepanova Vocal Integration System (SVIS) представляет собой комплексную профессиональную вокально-педагогическую систему, объединяющую современные подходы к развитию функционального певческого диапазона, регистровой интеграции, диагностике вокальных возможностей исполнителя и объективной оценке профессионального прогресса.</p><p>Методика применяется в работе с профессиональными вокалистами, используется преподавателями вокального искусства, внедряется в образовательную деятельность музыкальных академий и консерваторий, а также служит основой программ профессиональной подготовки и повышения квалификации педагогов.</p><p>Продолжая развиваться, SVIS сохраняет свою основную цель — создание единой воспроизводимой системы профессиональной вокальной подготовки, объединяющей современные педагогические технологии, практический исполнительский опыт и стандартизированные методические инструменты для подготовки вокалистов нового поколения.</p></div>
      </section>

      <div id="impact"><SvisImpactLead /></div>

      <SvisScaleSection />

      <SvisImpactSection />

      <div className="svis-content" id="method">
        <SvisMethodContent openModule={openModule} setOpenModule={setOpenModule} />
      </div>

      <section className="svis-reviews" id="reviews">
        <header className="svis-reviews__header">
          <span>Профессиональное мнение</span>
          <h2>Отзывы о методике SVIS</h2>
        </header>
        <div className="svis-reviews__grid">
          <article className="svis-review svis-review--featured">
            <div className="svis-review__person"><img className="svis-review__photo" src={reviewPhoto1} alt="Елена Владимировна Стаховская" /><div><h3>Елена Владимировна Стаховская</h3><p>профессор, Народная артистка Украины, заведующая кафедрой сольного пения Одесской национальной музыкальной академии имени А. В. Неждановой.</p></div></div>
            <div className="svis-review__quote"><p>«Методика регистровой интеграции и управляемого расширения вокального диапазона Татьяны Степановой представляет собой хорошо структурированный современный подход к профессиональной работе с певческим голосом. Особенно ценным я считаю то, что SVIS рассматривает расширение диапазона не как достижение отдельных крайних нот, а как последовательное включение нового участка голоса в устойчивый рабочий диапазон исполнителя.</p><p>Практический интерес представляет система работы с переходными зонами, функциональная карта диапазона и четкие критерии оценки стабильности новых нот. Такой подход дает преподавателю возможность не только слышать результат, но и последовательно отслеживать процесс формирования новой вокальной координации.</p><p>Отдельного внимания заслуживает возможность адаптации SVIS к индивидуальным характеристикам голоса. Для профессионального музыкального образования это принципиально важно: методика предлагает единый педагогический алгоритм, не лишая преподавателя возможности учитывать тип голоса, уровень подготовки и исполнительские задачи конкретного студента».</p></div>
          </article>

          <article className="svis-review">
            <div className="svis-review__person"><img className="svis-review__photo" src={reviewPhoto2} alt="Владимир Дантес" /><div><h3>Владимир Дантес</h3><p>украинский певец, телеведущий, радиоведущий и блогер.</p></div></div>
            <div className="svis-review__quote"><p>«До знакомства с SVIS моей основной сложностью был переход в верхнюю часть диапазона. Технически отдельные ноты были доступны, но я не мог стабильно использовать их в репертуаре: менялся тембр, появлялось лишнее усилие, а результат сильно зависел от состояния голоса.</p><p>Работа по системе Татьяны Степановой полностью изменила мое понимание диапазона. Мы перестали стремиться просто к более высоким нотам и начали работать над тем, чтобы каждая новая нота стала частью полноценного рабочего голоса. Последовательная работа с переходными зонами, стабилизация новой координации и дальнейший перенос техники в репертуар дали мне гораздо более устойчивый результат.</p><p>Для меня особенно важно, что SVIS не изменила индивидуальный характер моего голоса. Напротив, диапазон стал шире и свободнее, но тембр остался узнаваемым. Сегодня новые участки диапазона я могу использовать не только на занятиях, но и во время полноценного сценического исполнения».</p></div>
          </article>

          <article className="svis-review">
            <div className="svis-review__person"><img className="svis-review__photo" src={reviewPhoto3} alt="Валентина Антонюк" /><div><h3>Валентина Антонюк</h3><p>Доктор культурологии, профессор, Народная артистка Украины<br />Заведующая кафедрой камерного пения<br />Национальная музыкальная академия Украины имени П. И. Чайковского</p></div></div>
            <div className="svis-review__quote"><p>«В профессиональной вокальной педагогике особенно важны методики, которые позволяют соединить исполнительскую практику с понятной и воспроизводимой системой обучения. Именно этим, на мой взгляд, интересна Stepanova Vocal Integration System.</p><p>SVIS предлагает последовательно выстроенную модель работы с функциональным диапазоном: от первичной диагностики и определения переходных участков до регистровой интеграции, стабилизации новых нот и их переноса в музыкальный материал.</p><p>Отдельную профессиональную ценность представляет разграничение потенциального и функционального диапазона. Для подготовки профессионального певца недостаточно добиться физической доступности новой ноты — необходимо обеспечить ее интонационную, тембральную и исполнительскую устойчивость. В SVIS этот принцип получает конкретное методическое воплощение.</p><p>Система может быть полезна не только студентам-вокалистам, но и преподавателям, поскольку предоставляет структурированные инструменты наблюдения, контроля и оценки профессионального развития певческого голоса».</p></div>
          </article>

          <article className="svis-review">
            <div className="svis-review__person"><img className="svis-review__photo" src={reviewPhoto4} alt="Татьяна Русова" /><div><h3>Татьяна Русова</h3><p>Преподаватель-методист, доцент, Заслуженный деятель искусств Украины<br />Председатель цикловой комиссии «Эстрадное пение»<br />Киевская муниципальная академия музыки имени Р. М. Глиэра</p></div></div>
            <div className="svis-review__quote"><p>«SVIS представляет интерес именно как система, которую можно интегрировать в практическую подготовку современных вокалистов. Методика дает преподавателю четкую последовательность работы: диагностика голоса, определение функционального диапазона, работа с переходными зонами, последовательная интеграция новых нот и последующий перенос результата в репертуар.</p><p>Особенно важным для эстрадного исполнителя является принцип сохранения индивидуального тембра. Расширение диапазона не должно приводить к обезличиванию голоса или формированию одинаковой манеры звучания у разных студентов. SVIS позволяет сочетать техническое развитие с сохранением исполнительской индивидуальности.</p><p>Практическую ценность имеет и система оценки результата: новая нота рассматривается как освоенная только после того, как исполнитель способен стабильно использовать ее в музыкальной фразе. Такой подход помогает связать вокальную технику непосредственно со сценической практикой».</p></div>
          </article>

          <article className="svis-review">
            <div className="svis-review__person"><img className="svis-review__photo" src={reviewPhoto5} alt="Лариса Деркач" /><div><h3>Лариса Деркач</h3><p>Кандидат искусствоведения, доцент<br />Заведующая кафедрой сольного пения и оперной подготовки<br />Харьковский национальный университет искусств имени И. П. Котляревского</p></div></div>
            <div className="svis-review__quote"><p>«Одной из наиболее сложных задач профессионального обучения певца является достижение технической свободы в переходных участках диапазона без нарушения общей тембральной целостности голоса. В системе SVIS эта проблема рассматривается комплексно.</p><p>Методика Татьяны Степановой отличается последовательной архитектурой: исполнитель не переходит к расширению диапазона до формирования стабильной базовой координации, а каждая новая зона проходит несколько этапов — от технической доступности до полноценного использования в профессиональном репертуаре.</p><p>Педагогически интересным является SVIS Register Bridge Protocol, где переходный участок рассматривается не как препятствие между регистрами, а как отдельная функциональная зона, требующая последовательной интеграции.</p><p>Для преподавательской практики важна воспроизводимость системы: диагностические карты, критерии стабильности и поэтапный алгоритм позволяют адаптировать ее к разным голосам, сохраняя индивидуальный подход к каждому студенту».</p></div>
          </article>
        </div>
      </section>

      <section className="svis-contact" id="contact">
        <div className="svis-contact__intro">
          <span>Контакт с SVIS</span>
          <h2>Обсудим обучение и применение методики</h2>
          <p>Оставьте сообщение, если хотите узнать больше о программе, подготовке преподавателей или возможностях внедрения SVIS.</p>
          <div className="svis-contact__signal" aria-hidden="true">{[30,58,86,45,72,96,62,38,78,52,90,42].map((height, index) => <i key={index} style={{ "--contact-wave": `${height}%`, "--contact-index": index }} />)}</div>
        </div>
        <form className="svis-contact__form" onSubmit={handleContactSubmit}>
          <label><span>Ваше имя</span><input name="name" type="text" placeholder="Татьяна" required /></label>
          <label><span>Email</span><input name="email" type="email" placeholder="name@example.com" required /></label>
          <label className="svis-contact__message"><span>Сообщение</span><textarea name="message" rows="6" placeholder="Расскажите, что вас интересует" required /></label>
          <button type="submit">Отправить сообщение <i>↗</i></button>
          <div className={`svis-contact__status ${formStatus ? "is-visible" : ""}`} role="status" aria-live="polite">{formStatus}</div>
        </form>
      </section>

      <footer className="svis-footer"><b>SVIS</b><span className="svis-footer__name">Stepanova Vocal Integration System</span><span className="svis-footer__copyright">© 2026 Все права защищены.</span><a href="#top">Наверх ↑</a></footer>
    </main>
  );
}

export default App;
